module.exports = __webpack_public_path__ + "static/tevei-renvoye-2PbzxoT4me4-unsplash-7d7bdb80aa5c9bc4660eebe581307ad3.jpg";